// import emoji from "react-easy-emoji";

import microsoft from "./assets/img/icons/common/microsoft.png";
import cyberTrace from "./assets/img/icons/common/cyberTrace.png";
import ARSII from "./assets/img/icons/common/arsii.png";
import capgemini from "./assets/img/icons/common/capgemini.png";
import proxym from "./assets/img/icons/common/proxym.png";
import uwstout from "./assets/img/icons/common/uwstout.png";
import astrolab from "./assets/img/icons/common/astrolab.png";
import c4sam from "./assets/img/icons/common/C4SAM.png";
import dassault from "./assets/img/icons/common/3ds.png";
import cihub from "./assets/img/icons/common/cihub.png";
//import project previews
import memeGenerator from "./assets/img/previews/meme_generator_preview.png";
import booky from "./assets/img/previews/booky_preview.png";
import chkoba from "./assets/img/previews/chkoba_preview.png";
import themaze from "./assets/img/previews/the_maze_preview.jpg";
import studyBuddy from "./assets/img/previews/study_buddy_preview.png";
import gitopsdemo from "./assets/img/previews/gitops_demo_preview_2.svg";
// import terraform from "./assets/img/previews/terraform_preview.webp";
import terraform from "./assets/img/previews/terraform.svg";


export const greetings = {
  name: "Mehdi Ben Hariz",
  title: "Hi there, I'm Mehdi",
  description:
    "I turn ideas into production systems — clean backends, smooth pipelines, and a touch of AI magic. From first commit to final deploy, I build software that ships.",
  resumeLink: "_Resume_Mehdi_Ben_Hariz.pdf",
};

export const openSource = {
  githubUserName: "mehdi-benhariz",
};

export const contact = {};

export const socialLinks = {
  meduim: "https://medium.com/@benharizmehdi20",
  blogger: "https://blogging--it.blogspot.com/",
  github: "https://github.com/mehdi-benhariz",
  linkedin: "https://www.linkedin.com/in/mehdi-ben-hariz/",
};

export const skillsSection = {
  title: "What I do",
  subTitle:
    "A software engineer passionate with solving real-world problem and building efficient solution",
  skills: [
    "⚡ Lead the development of a product from the scratch to the production",
    "⚡ Implement DevOps practices and pipelines to automate tasks ",
    "⚡ Integrate AI modules to enhance user experience and optimize processes",
  ],
  //icon source is ,fontawesome
  softwareSkills: [
    // {
    //   skillName: "html-5",
    //   fontAwesomeClassname: "vscode-icons:file-type-html",
    // },
    // {
    //   skillName: "css3",
    //   fontAwesomeClassname: "vscode-icons:file-type-css",
    // },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "logos:javascript",
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "logos:typescript-icon",
    },
    {
      skillName: "python",
      fontAwesomeClassname: "logos:python",
    },
    {
      skillName: "java",
      fontAwesomeClassname: "logos:java",

    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "vscode-icons:file-type-reactjs",
    },
    // {
    //   skillName: "flutter",
    //   fontAwesomeClassname: "logos:flutter",
    // },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "logos:nodejs-icon",
    },
    {
      skillName: "express",
      fontAwesomeClassname: "logos:express",
    },
    {
      skillName: "nestjs",
      fontAwesomeClassname: "logos:nestjs",
    },
    {
      skillName: "dotnet",
      fontAwesomeClassname: "logos:dotnet",
    },
    {
      skillName: "django",
      fontAwesomeClassname: "logos:django",
    },
    {
      skillName: "mysql",
      fontAwesomeClassname: "vscode-icons:file-type-mysql",
    },
    {
      skillName: "postgresql",
      fontAwesomeClassname: "logos:postgresql",
    },

    {
      skillName: "mongoDB",
      fontAwesomeClassname: "logos:mongodb",
    },
    {
      skillName: "C",
      fontAwesomeClassname: "logos:c",
    },
    {
      skillName: "CPP",
      fontAwesomeClassname: "logos:c-plusplus",
    },
    // {
    //   skillName: "java",
    //   fontAwesomeClassname: "logos:java",
    // },
    {
      skillName: "kubernetes",
      fontAwesomeClassname: "logos:kubernetes",
    },
    {
      skillName: "git",
      fontAwesomeClassname: "logos:git-icon",
    },
    {
      skillName: "linux",
      fontAwesomeClassname: "logos:linux-tux",
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "logos:docker-icon",
    },
    {
      skillName: 'azure',
      fontAwesomeClassname: 'logos:azure-icon',

    }
  ],
};

export const SkillBars = [
  {
    Stack: "Backend",
    progressPercentage: "90",
  },
  {
    Stack: "DevOps",
    progressPercentage: "60",
  },
  {
    Stack: "AI/ML",
    progressPercentage: "50",
  },
  // {
  //   Stack: "Frontend", //Insert stack or technology you have experience in
  //   progressPercentage: "78", //Insert relative proficiency in percentage
  // },
  // {
  //   Stack: "Mobile",
  //   progressPercentage: "50",
  // },
];

export const educationInfo = [
  {
    schoolName: "ISSATsousse",
    subHeader: "Integrated Preparatory Cycle",
    duration: "September 2019 - June 2021",
    desc: "Studied Subjects in Maths, Physics and Computer Science.",
    descBullets: ["I was a Valdectorian of my promotion"],
  },
  {
    schoolName: "UW-Stout - USA",
    subHeader: "Computer Science degree",
    duration: "September 2022 - Mai 2023",
    desc:
    "1 year as an Exchange Student as part of international Scholarship program.",
    descBullets: ["Chosen with 32 other students from 10k candidats"],
  },
  {
    schoolName: "ISSATsousse",
    subHeader: "Software Engineering degree",
    duration: "September 2021 - Jully 2025",
    desc: "Studied Software Engineering.",
    descBullets: [],
  },
];

export const internships = [
  {
    role: "Mobile App Intern",
    company: "ARSII",
    companylogo: ARSII,
    date: "July 2021 – September 2021",
    desc: "Participated in the conception, prototyping, implementation and deployment of a cross-platform mobile app.",
  },
  {
    role: "Consultant Assistant",
    company: "Capgemini",
    companylogo: capgemini,
    date: "February 2022 – May 2022",
    desc: "Part of the Chinese architect community program. Learned and tested DevOps tools under the supervision of a company architect.",
  },
  {
    role: "Web Dev Intern",
    company: "Proxym-group",
    companylogo: proxym,
    date: "June 2022 – July 2022",
    desc: "Implemented the maker-checker concept in a web app designed for financial services using .NET and React.",
  },
  {
    role: "Research Intern",
    company: "UW-Stout",
    companylogo: uwstout,
    date: "February 2023 – April 2023",
    desc: "Worked with my supervisor on NoSQL databases, comparing different use cases and scenarios, presented findings at Research Day.",
  },
];

export const communityExperience = [
  {
    role: "President",
    company: "Microsoft Issatso Club",
    companylogo: microsoft,
    date: "December 2019 – April 2022",
    desc: "Led and grew the club across multiple roles and responsibilities. Active member since the club's founding in 2019.",
  },
  {
    role: "Dev Team Member",
    company: "CyberTrace Club",
    companylogo: cyberTrace,
    date: "July 2021 – April 2022",
    desc: "Participated in the development of a web application for the club as a backend developer.",
  },
];

export const experience = [
  {
    role: "Backend Developer",
    company: "Astrolab Agency",
    companylogo: astrolab,
    date: "June 2023 – April 2024",
    desc:
      "I am participating in the lifecycle of developing Software solutions using Nestjs.",
  },
  {
    role: "Software   & Data science Engineer Intern",
    company: "Dassault Systèmes",
    companylogo: dassault,
    date: "February 2025 – July 2025",
    desc:
    "I am responsible for implementing a solution for log ingestion and analysis using Java , Python and Grafana .",
  },
  
    {
      role: "Backend / DevOps Engineer (Consultant)",
      company: "C4SAM",
      companylogo: c4sam,
      date: "July 2024 – January 2026",
      desc:
        "I am responsible for implementing and maintaining a product for DevSecOps tools integration",
    } ,
    {
      role: "Backend / AI Engineer",
      company: "CI-HUB",
      companylogo: cihub,
      date: "January 2026 – Present",
      desc:
        "I am responsible for implementing and maintaining the backend and AI projects for the company",
    } ,
];

export const projects = [
  {
    name: "Mic Event Pro Apps",
    github: "https://shorturl.at/rnjse",
    link: "https://themaze.microsoftissatso.tn/",
    preview: themaze,
  },
  {
    name: "GitOps Demo",
    github: "https://github.com/mehdi-benhariz/demo-gitops",
    preview: gitopsdemo,
    link: "https://projects.mehdibenhariz.dev/project/2"
  },
  {
    name: "Chkobba -  Card game",
    link: "https://chkoba.mehdibenhariz.dev/",
    github: "https://github.com/mehdi-benhariz/Chkoba",
    preview: chkoba,

  },
  {
    name: "Terraform Dev Environment",
    link: "https://github.com/mehdi-benhariz/dev-env-tarraform",
    github: "https://github.com/mehdi-benhariz/dev-env-tarraform",
    preview: terraform,

  },
  {
    name: "Meme generator",
    // github: "https://github.com/mehdi-benhariz/meme-generator",
    link: "https://study-bud.mehdibenhariz.dev/",
    preview: memeGenerator,
  },
  // {
  //   name: "Ecommerce plateform ",
  //   github: "https://github.com/mehdi-benhariz",
  //   preview: "",
  // },
  {
    name: "Booky",
    github: "https://github.com/mehdi-benhariz/Booky",
    link: "https://booky-smoky.vercel.app/",
    preview: booky,
  },
  {
    name: "AI studdy Buddy",
    // github: "https://github.com/mehdi-benhariz/meme-generator",
    link: "https://study-bud.mehdibenhariz.dev/",
    preview: studyBuddy,
  },
  // {
  //   name: "covid tracker",
  //   github: "https://github.com/mehdi-benhariz/covid-tracker19",
  //   link: "http://covid-tracker19.surge.sh/",
  //   preview: "",
  // },
];

export const feedbacks = [
  {
    name: "Terrence Mason",
    feedback: ".",
  },
  {
    name: "Alexi",
    feedback: "",
  },
];
